import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledPath = styled.path`
  ${({ gfill, theme }) =>
    `fill: ${typeof gfill === 'function' ? gfill(theme) : gfill}`}
`;

const IconAppMenu = ({ fill, width, height }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 1024 1024"
  >
    <StyledPath
      gfill={fill}
      d="M128 76.8c-28.276 0.003-51.197 22.924-51.2 51.2v0 298.7c0.003 28.276 22.924 51.197 51.2 51.2h298.7c28.276-0.003 51.197-22.924 51.2-51.2v0-298.7c-0.003-28.276-22.924-51.197-51.2-51.2v0zM179.2 179.2h196.3v196.3h-196.3z"
    />
    <StyledPath
      gfill={fill}
      d="M597.3 76.8c-28.276 0.003-51.197 22.924-51.2 51.2v0 298.7c0.003 28.276 22.924 51.197 51.2 51.2h298.7c28.276-0.003 51.197-22.924 51.2-51.2v0-298.7c-0.003-28.276-22.924-51.197-51.2-51.2v0zM648.5 179.2h196.3v196.3h-196.3z"
    />
    <StyledPath
      gfill={fill}
      d="M597.3 546.1c-28.276 0.003-51.197 22.924-51.2 51.2v0 298.7c0.003 28.276 22.924 51.197 51.2 51.2h298.7c28.276-0.003 51.197-22.924 51.2-51.2v0-298.7c-0.003-28.276-22.924-51.197-51.2-51.2v0zM648.5 648.5h196.3v196.3h-196.3z"
    />
    <StyledPath
      gfill={fill}
      d="M128 546.1c-28.276 0.003-51.197 22.924-51.2 51.2v0 298.7c0.003 28.276 22.924 51.197 51.2 51.2h298.7c28.276-0.003 51.197-22.924 51.2-51.2v0-298.7c-0.003-28.276-22.924-51.197-51.2-51.2v0zM179.2 648.5h196.3v196.3h-196.3z"
    />
  </svg>
);

IconAppMenu.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

IconAppMenu.defaultProps = {
  width: '34',
  height: '34',
  fill: 'white',
};

export default IconAppMenu;
